import "../../pages/new/new.scss"

import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axios';
import TextBox from './TextBox';
import { Link } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';



export const AddThesis = () => {
    const [thesisTitle , setThesisTitle] = useState(null);
    const [mentor1Name , setMentor1Name] = useState(null);
    const [mentor2Name , setMentor2Name] = useState(null);
    const [id,setId] = useState(null);
      const fileInputRef1 = useRef(null);
      const fileInputRef2 = useRef(null);
      const fileInputRef3 = useRef(null);
    const [studentId] = useState(localStorage.getItem('studentId'));
      

    const { thesisId } = useParams();
    const [thesis, setThesis] = useState( {
        id: '',
        thesis_title: '',
        student_name: '',
        mentor1_name: '',
        mentor2_name: '',
        enrollment_number: '',
        student_id: '',
        thesis_abstract: '',
        keywords: '',
        mentorId1ReadyViva: '',
        mentorId2ReadyViva: '',
        immediateSupervisorName:'',
        immediateSuprevisorContact:''
    });

   
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [editMode, setEditMode] = useState(false);
    const [viewMode, setViewMode] = useState(false);
    const [showSecondPage, setShowSecondPage] = useState(false);
    const [thesisDetails,setThesisDetails] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true); 

    const fetchThesis = async (id) => {
        try {
            const response = await axiosInstance.get(`/getThesisById?id=${id}`);
          //  console.log("Fetched Thesis Data:", response.data.data);
    
            setThesis(response.data.data);
        } catch (error) {
            console.error("Error fetching thesis:", error);
        }
    };
            
    useEffect(() => {
        if (thesisId) {
            const path = window.location.pathname;
            if (path.includes('edit-thesis')) {
                setEditMode(true);
            }
            else if (path.includes('view-thesis')) {
                setViewMode(true);
            }
            fetchThesis(thesisId);
            // Set mode to edit if courseId is present
        } else {
            setEditMode(false); // Set mode to add if no courseId is present
            setViewMode(false);
        }
    }, [thesisId]);

    const getMentorIdByName = async (mentorName) => {
        if (!mentorName) return null;
        try {
            const response = await axiosInstance.get(`/instructors`);
            const instructors = response.data.data || [];
    
            const mentor = instructors.find(inst =>
                inst.name.trim().toLowerCase() === mentorName.trim().toLowerCase()
            );
    
            if (mentor) {
               // console.log(`Mentor ID for ${mentorName}:`, mentor.id);
                return mentor.id;
            } else {
                alert(`Mentor '${mentorName}' not found!`);
                console.error(`Mentor '${mentorName}' not found!`);
                return null;  
            }
        } catch (error) {
            console.error("Error fetching instructors:", error);
            return null;
        }
    };
    
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setThesis({ ...thesis, [name]: value || '' });
        setErrors({ ...errors, [name]: '' });
    };

    const goBack = async(e) => {
        navigate('/thesis');
        
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (!thesis.id) {
                alert("Thesis ID is missing! Update cannot proceed.");
                return;
            }
    
            // Convert mentor names to mentor IDs
            const mentor1Id = await getMentorIdByName(thesis.mentor1_name);
            const mentor2Id = await getMentorIdByName(thesis.mentor2_name);
            
            if (thesis.mentor1_name && mentor1Id === null) {
                console.error("Invalid Mentor 1 name entered!");
                return;
            }
            if (thesis.mentor2_name && mentor2Id === null) {
                console.error("Invalid Mentor 2 name entered!");
                return;
            }

            const updatedThesis = {
                id: thesis.id,
                studentId: thesis.student_id,
                title: thesis.thesis_title,
                mentorId1: mentor1Id !== null ? mentor1Id : "", 
                mentorId2: mentor2Id !== null ? mentor2Id : "" 
            };
        
            const response = await axiosInstance.put('/Thesis', updatedThesis, {
                headers: { "Content-Type": "application/json" }
            });
        
            if (response.status === 200) {
               // console.log("Thesis updated successfully:", response.data);
                alert("Thesis updated successfully!");
                navigate('/thesis');
    
            } else {
                console.error("Failed to update thesis:", response.data);
            }
        } catch (error) {
            console.error("Error updating thesis:", error.response ? error.response.data : error);
        }
        finally {
            setLoading(false);
        }
    };
    
                //     const requestData = {
                //         thesis: thesis,
                //         id: thesis.id,
                //         thesisTitle: thesisTitle,
                //         mentor1Name: mentor1Name,
                //         mentor2Name: mentor2Name
                //     };
                
                //     response = await axiosInstance.put('/Thesis', requestData, {
                //         headers: {
                //             'Content-Type': 'application/json'
                //         },
                //         showToastOnResponse: true
                //     });
                
                //     console.log(response);
                // }
                

    
const fetchThesisByStudentId = async (studentId) => {
    if (!studentId) {
      alert("Student ID is not available.");
      return;
    }
  
    try {
      const response = await axiosInstance.get(`/getThesisByStudentIdNumber?studentId=${studentId}`);
      //console.log("API Response:", response.data);
  
      if (response.data.data && response.data.data.length > 0) {
        const formattedData = response.data.data.map((item, index) => ({
          id: item.id,
          report_type: item.reportType || "N/A",
          folder_link: item.folderLink || "",
          date_submitted: item.dateSubmitted || "Not Submiited!",
        }));
  
        setThesisDetails(formattedData);
      } else {
        alert("No thesis found for the given Student ID.");
        setThesisDetails([]);
      }
    } catch (error) {
      console.error("Error fetching thesis by Student ID:", error);
      alert("Error fetching thesis. Please try again.");
    }
  };

  const columns = React.useMemo(
    () => [
      {
        field: 'report_type',
        headerName: 'Report Type',
        width: 250,
        renderCell: (params) => {
          return params.value === 'ProjectProposal' ? 'Project Proposal' : params.value;
        },
      },
      {
        field: 'folder_link',
        headerName: 'Folder Link',
        width: 250,
        renderCell: (params) => (

          <div style={{ display: 'flex', alignItems: 'center' }}>
            {params.value ? (
              <Link
                href={params.value}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
              >
                Open Folder
              </Link>
            ) : (
              'No Link Available'
            )}
          </div>
        ),
      },
      {
        field: 'date_submitted',
        headerName: 'Date Submitted',
        width: 250,
        renderCell: (params) => {
          return params.value ? new Date(params.value).toLocaleDateString() : 'Not Submitted';
        },
      },
    ],
    []
  );

  const actionColumn = [{ field: "action", headerName:"Action", width:250,
          renderCell:(params)=>{
          //  console.log("params.row:", params.row);
          //  console.log("Extracted id:", params.row.id);

              const { id } = params.row;
              return(
                  <div className="cellAction">
                      <div className="viewButton"><Link to={{pathname: `/thesis/view-thesis-details/${id}`}} style={{textDecoration:"none" }}>View</Link></div>
                  </div>
              );
          }
      }]

    return (
        <div>
            <div className="top" style={{ display: "flex", alignItems: "flex-start", gap: "20px", width: "100%" }}>
                <h1>{editMode ? 'Edit thesis' : viewMode ? 'View thesis' : 'Add thesis'}</h1>
            </div>
            <div className="bottom" >
                <div className="left"></div>
                <div className="right" style={{ flex: "1", padding: "20px", border: "1px solid #ccc", borderRadius: "8px" }}>
                    <form onSubmit={handleSubmit}>
                    {!showSecondPage ? (
                        // FIRST 5 FIELDS
                        <>
                        {!viewMode && <div className="formInput">
              Update Thesis Title {' '}
              <input type="text" name="thesis_title" onChange={handleChange} value={thesis.thesis_title} />
              {errors.thesisTitleData && <div className="error-text">{errors.thesisTitleData}</div>}
            </div>}

            {!viewMode && <div className="formInput">
              Update Mentor 1 Name {' '}
              <input type="text" name="mentor1_name" onChange={handleChange} value={thesis.mentor1_name } />
              {errors.mentor1NameData && <div className="error-text">{errors.mentor1NameData}</div>}
            </div>}

            {!viewMode && <div className="formInput">
              Update Mentor 2 Name{' '}
              <input type="text" name="mentor2_name" onChange={handleChange} value={thesis.mentor2_name } />
              {errors.mentor2NameData && <div className="error-text">{errors.mentor2NameData}</div>}
            </div>}

            {!viewMode && <div className="buttons">
                            <button type="submit">{editMode ? 'Update' : 'Save'}</button>
                            <button onClick={goBack}>Back</button>
                        </div>}
                        
            {viewMode && <div className="formInput">
                            <label>Enrollment Number </label>
                            <input type="text"
                                name="enrollment_number"
                                value={thesis.enrollment_number}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.enrollment_number ? 'error' : ''} />
                            {errors.enrollment_number && <div className="error-text">{errors.enrollment_number}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label>Student Name </label>
                            <input type="text"
                                name="student_name"
                                value={thesis.student_name}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.student_name ? 'error' : ''} />
                            {errors.student_name && <div className="error-text">{errors.student_name}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label>Thesis Title </label>

                            <TextBox type="text"
                                name="thesis_title"
                                value={thesis.thesis_title}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.thesis_title ? 'error' : ''} />
                            {errors.thesis_title && <div className="error-text">{errors.thesis_title}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label>Mentor1 Name </label>
                            <input type="text"
                                name="mentor1_name"
                                value={thesis.mentor1_name}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.mentor1_name ? 'error' : ''} />
                            {errors.mentor1_name && <div className="error-text">{errors.mentor1_name}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label>Mentor2 Name </label>
                            <input type="text"
                                name="mentor2_name"
                                value={thesis.mentor2_name}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.mentor2_name ? 'error' : ''} />
                            {errors.mentor2_name && <div className="error-text">{errors.mentor2_name}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label>Abstract</label>
                            <TextBox style={{ width: '100%', height: 'auto' }}
                                name="thesis_abstract"
                                value={thesis.thesis_abstract}
                                readOnly={viewMode}
                                onChange={handleChange}
                                className={errors.thesis_abstract ? 'error' : ''} />
                            {errors.thesis_abstract && <div className="error-text">{errors.thesis_abstract}</div>}
                        </div>}
                <div>
                 {viewMode && <div className="buttons">
                 <button onClick={() => setShowSecondPage(true)} style={{ background: "blue", color: "white" }}>Expand Info</button>
                <button onClick={goBack} style={{ background: "blue", color: "white" }}>Back</button>
                <button type="button" onClick={() => fetchThesisByStudentId(thesis?.student_id)} style={{ background: "blue", color: "white" }}>
                    Submissions
                </button>
                    </div>}


                </div>
                    </>
                ) : (
                    <>
                    {viewMode && <div className="formInput">
                            <label>Enrollment Number </label>
                            <input type="text"
                                name="enrollment_number"
                                value={thesis.enrollment_number}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.enrollment_number ? 'error' : ''} />
                            {errors.enrollment_number && <div className="error-text">{errors.enrollment_number}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label>Student Name </label>
                            <input type="text"
                                name="student_name"
                                value={thesis.student_name}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.student_name ? 'error' : ''} />
                            {errors.student_name && <div className="error-text">{errors.student_name}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label>Thesis Title </label>

                            <TextBox type="text"
                                name="thesis_title"
                                value={thesis.thesis_title}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.thesis_title ? 'error' : ''} />
                            {errors.thesis_title && <div className="error-text">{errors.thesis_title}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label>Mentor1 Name </label>
                            <input type="text"
                                name="mentor1_name"
                                value={thesis.mentor1_name}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.mentor1_name ? 'error' : ''} />
                            {errors.mentor1_name && <div className="error-text">{errors.mentor1_name}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label>Mentor2 Name </label>
                            <input type="text"
                                name="mentor2_name"
                                value={thesis.mentor2_name}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.mentor2_name ? 'error' : ''} />
                            {errors.mentor2_name && <div className="error-text">{errors.mentor2_name}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label>Abstract</label>
                            <TextBox style={{ width: '100%', height: 'auto' }}
                                name="thesis_abstract"
                                value={thesis.thesis_abstract}
                                readOnly={viewMode}
                                onChange={handleChange}
                                className={errors.thesis_abstract ? 'error' : ''} />
                            {errors.thesis_abstract && <div className="error-text">{errors.thesis_abstract}</div>}
                        </div>}
                        {viewMode && <div className="formInput">
                            <label>Keywords </label>
                            <TextBox type="text"
                                name="keywords"
                                value={thesis.keywords}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.keywords ? 'error' : ''} />
                            {errors.keywords && <div className="error-text">{errors.keywords}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label>mentor1 ready for viva </label>
                            <input type="text"
                                name="mentorId1ReadyViva"
                                value={thesis.mentorId1ReadyViva}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.mentorId1ReadyViva ? 'error' : ''} />
                            {errors.mentorId1ReadyViva && <div className="error-text">{errors.mentorId1ReadyViva}</div>}
                        </div>}


                        {viewMode && <div className="formInput">
                            <label>mentor2 ready for viva </label>
                            <input type="text"
                                name="mentorId2ReadyViva"
                                value={thesis.mentorId2ReadyViva}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.mentorId2ReadyViva ? 'error' : ''} />
                            {errors.mentorId2ReadyViva && <div className="error-text">{errors.mentorId2ReadyViva}</div>}
                        </div>}
                        {viewMode && <div className="formInput">
                            <label>Immediate Supervisor Name </label>
                            <input type="text"
                                name="immediateSupervisorName"
                                value={thesis.immediateSupervisorName}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.immediateSupervisorName ? 'error' : ''} />
                            {errors.immediateSupervisorName && <div className="error-text">{errors.immediateSupervisorName}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label>Immediate Supervisor Contact </label>
                            <input type="text"
                                name="immediateSupervisorContact"
                                value={thesis.immediateSupervisorContact}
                                onChange={handleChange}
                                readOnly={viewMode}
                                className={errors.immediateSuprevisorContact ? 'error' : ''} />
                            {errors.immediateSuprevisorContact && <div className="error-text">{errors.immediateSuprevisorContact}</div>}
                        </div> }
                        <div className="buttons">
                            <button onClick={() => setShowSecondPage(false)}>Back</button>
                        </div>
                    </>)}

                {thesisDetails.length > 0 ? (
                    <div className="datatable" >
                    <div className="datatableTitle"></div>
                    <DataGrid
                        rows={thesisDetails} // Update rows with fetched thesis data
                        columns={columns.concat(actionColumn)}
                        pageSizeOptions={[5, 10]}
                        disableSelectionOnClick
                        />

                      </div>
                    
                ) : (
                    thesisDetails.length === 0 && <p></p>
                )}  
                </form>
                
            </div>
        </div>
        </div>
    );
};
